import React from "react";
import { Spinner } from "@heroui/react";

/**
 * `inset` centers within the app shell's content area (viewport minus the
 * 4rem topbar and main's 3rem vertical padding) instead of a full screen
 * starting below the topbar, which pushed the spinner below center.
 */
function ThemedSuspense({ inset = false }) {
  return (
    <div
      className={`flex justify-center items-center ${
        inset ? "h-[calc(100vh-7rem)]" : "h-screen"
      }`}
    >
      <Spinner size="lg" color="current" className="text-muted" />
    </div>
  );
}

export default ThemedSuspense;
